// extracted by mini-css-extract-plugin
export var filterIncDec = "_ej-0";
export var leftBorder = "_ej-1";
export var rightBorder = "_ej-2";
export var stringInput = "_ej-3";